import { Seo } from '../components/Seo';

export function QVisitPage() {
  return (
    <section className="qr-mobile q-landing-shell">
      <Seo title="타로맨스 | Q Visit" description="QR 전용 방문 정보 페이지" />
      <article className="card q-landing-card">
        <p className="eyebrow">Q Visit</p>
        <h1>방문 정보를 빠르게 확인하세요.</h1>
        <ul className="home-list">
          <li>서울 강남구 도곡로 11길 10 1층</li>
          <li>17:00 - 03:00 / 연중무휴</li>
          <li>문의: 0507-1361-9410</li>
        </ul>
      </article>
    </section>
  );
}
